export const HOURS_PER_DAY = 24;
export const DAYS_PER_WEEK = 7;
export const GAME_LENGTH_DAYS = 30;
export const GAME_LENGTH_HOURS = GAME_LENGTH_DAYS * HOURS_PER_DAY;

export type Weekday = 'seg' | 'ter' | 'qua' | 'qui' | 'sex' | 'sab' | 'dom';

export const WEEKDAYS: readonly Weekday[] = Object.freeze([
  'seg',
  'ter',
  'qua',
  'qui',
  'sex',
  'sab',
  'dom',
]);

export type Clock = {
  readonly tick: number;
};

export function createClock(init: Partial<Clock> = {}): Clock {
  return Object.freeze({
    tick: Math.max(0, Math.trunc(init.tick ?? 0)),
  });
}

export function advance(clock: Clock, hours: number): Clock {
  if (!Number.isInteger(hours) || hours < 0) {
    throw new Error(`Avanço inválido: ${hours} (deve ser inteiro não-negativo)`);
  }
  return createClock({ tick: clock.tick + hours });
}

export function day(clock: Clock): number {
  return Math.floor(clock.tick / HOURS_PER_DAY);
}

export function hour(clock: Clock): number {
  return clock.tick % HOURS_PER_DAY;
}

export function weekday(clock: Clock): Weekday {
  return WEEKDAYS[day(clock) % DAYS_PER_WEEK]!;
}

export function isWeekend(clock: Clock): boolean {
  const wd = weekday(clock);
  return wd === 'sab' || wd === 'dom';
}

export function isGameOver(clock: Clock): boolean {
  return clock.tick >= GAME_LENGTH_HOURS;
}

export function isOpenAt(open: number, close: number, currentHour: number): boolean {
  if (open === close) return true;
  if (open < close) return currentHour >= open && currentHour < close;
  return currentHour >= open || currentHour < close;
}
